import http from '../http'

function upload(url, file, onProgress) {
  const formData = new FormData()
  formData.append('file', file)
  return http.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 600000,
    onUploadProgress: event => {
      if (onProgress && event.total) {
        onProgress({ percent: Math.round((event.loaded * 100) / event.total) })
      }
    }
  })
}

export function uploadContractAttachment(contractId, file, onProgress) {
  return upload(`/business-documents/contracts/${contractId}`, file, onProgress)
}

export function getContractAttachments(contractId) {
  return http.get(`/business-documents/contracts/${contractId}`)
}

export function uploadTemporaryContractAttachment(uploadToken, file, onProgress) {
  return upload(`/business-documents/contracts/temp/${uploadToken}`, file, onProgress)
}

export function getTemporaryContractAttachments(uploadToken) {
  return http.get(`/business-documents/contracts/temp/${uploadToken}`)
}

export function bindTemporaryContractAttachments(contractId, uploadToken) {
  return http.post(`/business-documents/contracts/${contractId}/bind`, null, {
    params: { uploadToken }
  })
}

export function uploadBusinessLicense(unitInfoId, file) {
  return upload(`/business-documents/units/${unitInfoId}/business-license`, file)
}

export function getBusinessLicense(unitInfoId) {
  return http.get(`/business-documents/units/${unitInfoId}/business-license`)
}

export function downloadBusinessDocument(documentId) {
  return http.get(`/business-documents/${documentId}/download`, {
    responseType: 'blob'
  })
}

export function deleteBusinessDocument(documentId) {
  return http.delete(`/business-documents/${documentId}`)
}
